export default {
  props: {
    /**
     * How should this animate
     * todo: this is not working fully
     * @values [animation-class-name], true, false
     **/
    animation: {
      type: [String, Boolean],
      default: true,
    },
    /**
     * Type of alert
     * @values primary, success, warning, danger
     **/
    type: {
      type: String,
      default: "primary",
    },
    /**
     * Close icon type.
     * If default, will close itselve. Can have event firing instead (self clsoe fires event also)
     * If none, no close icon will show
     * TODO: closeType:none is duplicate of selfClose...
     * @values default, event, none
     */
    closeType: {
      type: String,
      default: "default",
    },
  },
  data: function () {
    return {};
  },
  computed: {
    alertClass() {
      return ["uk-alert", "uk-alert-" + this.type];
    },

    showClose() {
      return this.closeType !== "none";
    },
    closeAsEvent() {
      return this.closeType === "event";
    },
    selfClose() {
      return this.closeType === "default";
    },
  },
  methods: {
    close() {
      this.$s.ui.alert(this.$refs.alertWrapper).close();
    },
  },
  created() {},
};
